import { GlobalConfigState } from '@/interfaces/config';
import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  state: {} as GlobalConfigState,
  actions,
  getters,
  mutations,
};
